import { render, staticRenderFns } from "./RiskInstrument.vue?vue&type=template&id=78f79a26&lang=pug"
import script from "./RiskInstrument.vue?vue&type=script&lang=js"
export * from "./RiskInstrument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports